/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import ColAtm from "../../../../../atomic/Col/Col";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {Hidden} from "@material-ui/core";
import {
    CONTENT_ROOM_AMENITIES,
    CONTENT_ROOM_PHOTOS, CONTENT_ROOMS
} from "../../../../../../constants/appUrls.constants";

const useStyles = makeStyles(theme => ({
    root: {
        height: '40px',
        textAlign: 'center',
        color: '#e46a6b',
        background: '#fae1e1',
    },
    aLink: {
        margin: 'auto',
        color: '#e46a6b',
        fontSize: '14px',
        fontWeight: '500',
        "&:hover, &:focus": {
            color: '#e46a6b'
        },
    }
}));

export default function RoomMenu(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Hidden xsDown>
            <ColAtm md={12} className={classes.root}>
                <ColAtm className={props.createRoomColClass} sm={4}>
                    <Link to={CONTENT_ROOMS} className={classes.aLink} disabled={props.createRoomDisabled}>
                         { t('enw-room-tab-rooms') }
                    </Link>
                </ColAtm>
                <ColAtm className={props.amenitiesRoomsColClass} sm={4}>
                    <Link to={CONTENT_ROOM_AMENITIES} className={classes.aLink} disabled={props.amenitiesRoomsDisabled}>
                        { t('enw-room-tab-room_amenities') }
                    </Link>
                </ColAtm>
                <ColAtm className={props.roomPhotosColClass} sm={4}>
                    <Link to={CONTENT_ROOM_PHOTOS} className={classes.aLink} disabled={props.roomPhotosDisabled}>
                        { t('enw-room-tab-room_photos') }
                    </Link>
                </ColAtm>
            </ColAtm>
        </Hidden>
    );
}
RoomMenu.propTypes = {
    text: PropTypes.string,
    createRoomColClass: PropTypes.string,
    amenitiesRoomsColClass: PropTypes.string,
    roomPhotosColClass: PropTypes.string,
    createRoomDisabled: PropTypes.bool,
    amenitiesRoomsDisabled: PropTypes.bool,
    roomPhotosDisabled: PropTypes.bool,
};
